import Swiper from 'swiper';
import domReady from '@wordpress/dom-ready';

const MOBILE_BREAKPOINT = 768;
let swiper = null;

function initSwiper() {
  const slider = document.querySelector('.upcoming-events__swiper');

  if (!slider) {
    return;
  }

  if (window.innerWidth < MOBILE_BREAKPOINT) {
    if (!swiper) {
      swiper = new Swiper(slider, {
        slidesPerView: 1.1,
        spaceBetween: 16,
      });
    }
  } else if (swiper) {
    swiper.destroy(true, true);
    swiper = null;
  }
}

domReady(() => {
  initSwiper();
});

window.addEventListener('resize', initSwiper);
